import PurchaseLoginModal from "./PurchaseLoginModal";

export default PurchaseLoginModal;